import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import Translate from './Translate';
import translator from '../translations/drupalTranslator';
import LoadableSubmit from './loadableComponents/LoadableSubmit';

import CheckboxInput from './formComponents/CheckboxInput';
import TextInput from './formComponents/TextInput';

const AbandonBasketModal = props => {
  const { actions, appearance, order, errors, validatorFactory } = props;
  const renderingConf = appearance.addressFormat;
  const requiredFields = order.agency.creditAgency
    ? renderingConf.required_fields_credit_agencies
    : renderingConf.required_fields; // Default to normal customer
  const params = {
    onChange: actions.updateCustomerInfo,
    errors: errors.customerInfo,
    order,
    requiredFields,
    interactCustomerInfo: actions.interactCustomerInfo,
    validate: data =>
      new validatorFactory().then(factory => {
        return factory.getAbandonBasketValidator(data);
      }),
  };

  const submitForm = () => {
    if (!appearance.acceptedAbandonBasketTerms) {
      actions.customerError({
        name: 'abandonBasketTerms',
        value: 'Please agree with terms',
      });
    } else {
      actions.customerError({
        name: 'abandonBasketTerms',
        value: null,
      });
      if (
        Object.entries(errors.customerInfo).length === 0 ||
        !errors.customerInfo.abandonEmail
      ) {
        actions.startSubmitLoading(true);
        actions.submitAbandonBasket(order);
      }
    }
  };

  return (
    <Modal
      className="abandon-basket-modal"
      isOpen={appearance.showAbandonBasketPopup}
      onRequestClose={actions.hideAbandonBasket}
      overlayClassName="abandon-basket-modal__overlay"
    >
      <div>
        <div
          className="abandon-basket-modal__close-button"
          onClick={actions.hideAbandonBasket}
        />

        {appearance.abandonEmailSent ? (
          <>
            <Translate
              className="abandon-basket-modal__heading"
              component="h1"
              content="Email sent"
            />
            <div className="abandon-basket-modal__icon">
              <div className="checkmark checkmark--invert">
                <div className="checkmark__background" />
                <div className="checkmark__icon checkmark__icon--draw" />
              </div>
            </div>

            <Translate
              className="abandon-basket-modal__sub-text"
              component="p"
              content="We have sent the booking to"
            />
            <p className="abandon-basket-modal__important-text">
              {order.customer.abandonEmail}
            </p>
          </>
        ) : (
          appearance.abandonEmailConfirmed ? (
              <>
                <Translate
                  className="abandon-basket-modal__heading"
                  component="h1"
                  content="Thank you"
                />
                <div className="abandon-basket-modal__icon">
                  <div className="checkmark checkmark--invert">
                    <div className="checkmark__background" />
                    <div className="checkmark__icon checkmark__icon--draw" />
                  </div>
                </div>

                <Translate
                  className="abandon-basket-modal__sub-text"
                  component="p"
                  content="You will now receive the booking email on:"
                />
                <p className="abandon-basket-modal__important-text">
                  {order.customer.abandonEmail}
                </p>
              </>
          ) : (
          <>
            <Translate
              className="abandon-basket-modal__heading"
              component="h1"
              content="Finish your booking later"
            />
            <Translate
              className="abandon-basket-modal__description"
              component="p"
              content="Enter your email address below and we will send you your commenced booking - No spam, no sign-up needed"
            />
            <div
              className={`form-field form-field--inline  ${
                errors.customerInfo && errors.customerInfo.abandonEmail
                  ? 'form-input form-input--error'
                  : ''
              }`}
            >
              <TextInput
                className="text-input text-input--inline"
                name="abandonEmail"
                onChange={params.onChange}
                placeholder={translator.translate('Your email')}
                type="email"
                validate={params.validate}
                value={order.customer.abandonEmail}
              />
              <LoadableSubmit
                className="page-actions__button page-actions__button--inline"
                content={translator.translate('Finish later')}
                loadingWrapClass="abandon-basket-modal__loader-container"
                onClick={() => submitForm()}
              />
            </div>
            <div className="abandon-basket-modal__errors">
              <ul className="error-list">
                {errors.customerInfo &&
                  errors.customerInfo.abandonBasketTerms && (
                    <Translate
                      component="li"
                      content={errors.customerInfo.abandonBasketTerms}
                    />
                )}
                {errors.customerInfo && errors.customerInfo.abandonEmail && (
                  <Translate
                    component="li"
                    content={errors.customerInfo.abandonEmail}
                  />
                )}
              </ul>
            </div>
            {/* <AbandonBasketEmail {...params} /> */}
            <div className="form-field">
              <CheckboxInput
                name="acceptBasketTerms"
                onChange={() => {
                  actions.toggleAbandonBasketTerms();
                }}
                value={appearance.acceptedAbandonBasketTerms}
              />
              <label htmlFor="acceptBasketTerms">
                <Translate content="Please send me a link by email so that I can complete my booking later" />
              </label>
              <p className="abandon-basket-modal__terms-text">
                <Translate content="Please note that the e-mail will be sent to you shortly and it is not possible for you to change your mind once you have clicked “Finish Later”. We will not send you any further emails unless you are already subscribed to our newsletter. Any personal data you have already entered into the booking form will be deleted from NOVASOL’s system as soon as the email is sent to you and your email address will be deleted immediately." />
              </p>
            </div>
          </>
          ))}
      </div>
    </Modal>
  );
};

AbandonBasketModal.PropTypes = {
  appearance:PropTypes.shape(),
  order:PropTypes.shape(),
  errors:PropTypes.shape(),
  validatorFactory:PropTypes.shape(),
  actions:PropTypes.shape({
    hideAbandonBasket:PropTypes.func.isRequired,
  }).isRequired,
};

export default AbandonBasketModal;
